"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorrowActionType = exports.RouterActionType = exports.fetchMerklAMMType = exports.findMerklAMMTypeDeprecated = exports.validateAndParseAddress = exports.validateSolidityTypeInstance = void 0;
const ethers_1 = require("ethers");
const graphql_request_1 = __importStar(require("graphql-request"));
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const constants_1 = require("../constants");
const constants_2 = require("./constants");
const merkl_1 = require("./merkl");
function validateSolidityTypeInstance(value, solidityType) {
    (0, tiny_invariant_1.default)(value.lte(constants_2.SOLIDITY_TYPE_MAXIMA[solidityType]), `${value} is not a ${solidityType}.`);
}
exports.validateSolidityTypeInstance = validateSolidityTypeInstance;
function validateAndParseAddress(address) {
    try {
        return ethers_1.utils.getAddress(address);
    }
    catch (error) {
        throw new Error(`${address} is not a valid address.`);
    }
}
exports.validateAndParseAddress = validateAndParseAddress;
const findMerklAMMTypeDeprecated = (bytes) => {
    var _a;
    if (!bytes || !ethers_1.utils.isBytesLike(bytes) || bytes === '0x')
        return merkl_1.AMMType.UniswapV3;
    try {
        const firstDecodedValue = (_a = ethers_1.utils.defaultAbiCoder.decode(['uint256'], bytes)[0]) === null || _a === void 0 ? void 0 : _a.toNumber();
        if (!Object.values(merkl_1.AMMType).includes(firstDecodedValue))
            return merkl_1.AMMType.UniswapV3;
        return firstDecodedValue;
    }
    catch (_b) {
        return merkl_1.AMMType.UniswapV3;
    }
};
exports.findMerklAMMTypeDeprecated = findMerklAMMTypeDeprecated;
const fetchMerklAMMType = (chainId, pool, env = 'prod') => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const promises = [];
    for (const amm of Object.keys(constants_1.calculatorUsedWrappersList === null || constants_1.calculatorUsedWrappersList === void 0 ? void 0 : constants_1.calculatorUsedWrappersList[chainId])) {
        const endpoint = (_b = (_a = (0, constants_1.merklSubgraphAMMEndpoints)(env)) === null || _a === void 0 ? void 0 : _a[chainId]) === null || _b === void 0 ? void 0 : _b[parseInt(amm)];
        promises.push((() => __awaiter(void 0, void 0, void 0, function* () {
            const query = (0, graphql_request_1.gql) `
          query Pool($poolId: ID!) {
            pool(id: $poolId) {
              id
            }
          }
        `;
            const res = yield (0, graphql_request_1.default)(endpoint !== null && endpoint !== void 0 ? endpoint : '', query, { poolId: pool.toLowerCase() });
            if (!!res.pool)
                return parseInt(amm);
        }))());
    }
    const resolvedPromises = yield Promise.allSettled(promises);
    for (const p of resolvedPromises) {
        if (p.status === 'fulfilled' && p.value !== undefined && parseInt((_c = p.value) === null || _c === void 0 ? void 0 : _c.toString()) == p.value)
            return p.value;
    }
    throw new Error('Unable to solve AMM type');
});
exports.fetchMerklAMMType = fetchMerklAMMType;
var RouterActionType;
(function (RouterActionType) {
    RouterActionType[RouterActionType["transfer"] = 0] = "transfer";
    RouterActionType[RouterActionType["wrapNative"] = 1] = "wrapNative";
    RouterActionType[RouterActionType["unwrapNative"] = 2] = "unwrapNative";
    RouterActionType[RouterActionType["sweep"] = 3] = "sweep";
    RouterActionType[RouterActionType["sweepNative"] = 4] = "sweepNative";
    RouterActionType[RouterActionType["uniswapV3"] = 5] = "uniswapV3";
    RouterActionType[RouterActionType["oneInch"] = 6] = "oneInch";
    RouterActionType[RouterActionType["claimRewards"] = 7] = "claimRewards";
    RouterActionType[RouterActionType["gaugeDeposit"] = 8] = "gaugeDeposit";
    RouterActionType[RouterActionType["borrower"] = 9] = "borrower";
    RouterActionType[RouterActionType["swapper"] = 10] = "swapper";
    RouterActionType[RouterActionType["mint4626"] = 11] = "mint4626";
    RouterActionType[RouterActionType["deposit4626"] = 12] = "deposit4626";
    RouterActionType[RouterActionType["redeem4626"] = 13] = "redeem4626";
    RouterActionType[RouterActionType["withdraw4626"] = 14] = "withdraw4626";
    RouterActionType[RouterActionType["prepareRedeemSavingsRate"] = 15] = "prepareRedeemSavingsRate";
    RouterActionType[RouterActionType["claimRedeemSavingsRate"] = 16] = "claimRedeemSavingsRate";
    RouterActionType[RouterActionType["swapIn"] = 17] = "swapIn";
    RouterActionType[RouterActionType["swapOut"] = 18] = "swapOut";
    RouterActionType[RouterActionType["claimWeeklyInterest"] = 19] = "claimWeeklyInterest";
    RouterActionType[RouterActionType["withdraw"] = 20] = "withdraw";
    RouterActionType[RouterActionType["mint"] = 21] = "mint";
    RouterActionType[RouterActionType["deposit"] = 22] = "deposit";
    RouterActionType[RouterActionType["openPerpetual"] = 23] = "openPerpetual";
    RouterActionType[RouterActionType["addToPerpetual"] = 24] = "addToPerpetual";
    RouterActionType[RouterActionType["veANGLEDeposit"] = 25] = "veANGLEDeposit";
    RouterActionType[RouterActionType["claimRewardsWithPerps"] = 26] = "claimRewardsWithPerps";
})(RouterActionType = exports.RouterActionType || (exports.RouterActionType = {}));
var BorrowActionType;
(function (BorrowActionType) {
    BorrowActionType[BorrowActionType["createVault"] = 0] = "createVault";
    BorrowActionType[BorrowActionType["closeVault"] = 1] = "closeVault";
    BorrowActionType[BorrowActionType["addCollateral"] = 2] = "addCollateral";
    BorrowActionType[BorrowActionType["removeCollateral"] = 3] = "removeCollateral";
    BorrowActionType[BorrowActionType["repayDebt"] = 4] = "repayDebt";
    BorrowActionType[BorrowActionType["borrow"] = 5] = "borrow";
    BorrowActionType[BorrowActionType["getDebtIn"] = 6] = "getDebtIn";
    BorrowActionType[BorrowActionType["permit"] = 7] = "permit";
})(BorrowActionType = exports.BorrowActionType || (exports.BorrowActionType = {}));
//# sourceMappingURL=utils.js.map